//Ce fichier exporte les contextes.

import React from "react"

export const ComposerContext = React.createContext(null)
